import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { Colors, Spacing, Typography } from '_styles';

// assets
import image from "_assets/images/PRM-Logo-PNG/logo.png";
import Lottie from "react-lottie";
import { RegisterTileButton, CustomModal } from "_molecules";

// icons
import { GiControlTower, GiCommercialAirplane } from "react-icons/gi";
import { BsChevronRight } from "react-icons/bs";
import { FaChalkboardTeacher, FaSuitcaseRolling } from "react-icons/fa";
import { AiOutlineDesktop } from 'react-icons/ai'
import { CiShop } from "react-icons/ci";

// images
import Image from 'react-bootstrap/Image';
import loadingBar from '_assets/images/PRM-Logo-PNG/loading-bar.json';

const Circle = (props) => {

    const loadingBarOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingBar,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    }

    return (
        <>
                <Container fluid={true} style={{marginTop:props.marginTop}}>
                    <Lottie options={loadingBarOptions} height={35} width={35} />
                </Container>
        </>
    );
}

const AccountTypeSelector = (props) => {
    
    const [airlineLoading, setAirlineLoading] = useState(false)
    const [airportLoading, setAirportLoading] = useState(false)
    const [modal, setModal] = useState(false)

    const handleClick = (type) => {
        props.handleClick(type)
    }

    return (
        <>
            <Container>
                
                <Container className="d-flex justify-content-center">
                    <Image src={image} height={150} width={150} style={{ display:'flex', justifyContent:'center' }} />
                </Container>
                
                <p style={{fontSize:48, fontWeight:'bold', textAlign:'center', marginTop:Spacing.SCALE_16, marginBottom:Spacing.SCALE_32}}>Who are you</p>
                
                <Container className="d-flex justify-content-center">
                    <RegisterTileButton 
                        title="Airport" 
                        text="" 
                        icon={<GiControlTower size={80} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        lowerIcon={<BsChevronRight size={32} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        onClick={()=>handleClick('airport')}
                    />
                    <RegisterTileButton 
                        title="Airline" 
                        text="" 
                        icon={<GiCommercialAirplane size={80} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        lowerIcon={<BsChevronRight size={32} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        onClick={()=>handleClick('airline')}
                    />
                    <RegisterTileButton 
                        title="Travel Agent" 
                        text="" 
                        icon={<AiOutlineDesktop size={80} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        lowerIcon={<BsChevronRight size={32} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        onClick={()=>handleClick('travel-agent')}
                    />
                    <RegisterTileButton 
                        title="Retailer" 
                        text="" 
                        icon={<CiShop size={80} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        lowerIcon={<BsChevronRight size={32} style={{paddingTop:Spacing.SCALE_12}} color='white'/>}
                        onClick={()=>handleClick('retailer')}
                    />
                </Container>

                <p style={{fontSize:28, fontWeight:'200', textAlign:'center', marginTop:Spacing.SCALE_64}}>Already have an account?<span onClick={()=>props.handleClick('login')} style={{cursor:'pointer', textDecoration:'underline', color:Colors.PRM_LIGHT_BLUE }}>Log in</span></p>

            </Container>

            <CustomModal 
                hide={()=>{setModal(false)}} 
                show={modal}
                title={'Not Available'}
                body={'Unfortunately, PRM Portal access is not yet available to Airlines or Regulators'}
                subbody={<p>Do you have any questions? <a href="http://prmassist.com/contact">contact</a> our team or keep up to date with PRM Assist and PRM Portal by following our <a href='https://twitter.com/PrmAssist'>twitter</a></p>}
                button={'Done'}
                openButton={()=>{setModal(false)}}
            />
        </>
    );
};

export default AccountTypeSelector;
